<template lang="pug">
  div(class="form-document-signatures")
    div(class="form-document-signatures__section")
      div(class="text-16px dark mb-4") {{ $t('Signs') }}
      template(v-if="!signatures.length")
        p {{ $t('None of the participants have signed the document yet') }}
      template(v-else)
        div(
          v-for="signature in signatures"
          :key="signature.id"
          class="form-document-signatures__item"
        )
          div
            e-svg-icon(size="xxlg") key-bg
          div
            div(class="text-14px dark") {{ signature.name }}
            div(class="form-document-signatures__item-bottom")
              div(class="text-12px light") {{ signature.code }}
              div(class="text-12px light dark") {{ formatTime(signature.signedAt) }}
    div(
      v-if="canSend && $User"
      class="form-document-signatures__section"
    )
      div(class="text-16px dark mb-4") {{ $t('Access to document') }}
      div(class="form-document-signatures__item")
        div(class="form-document-signatures__item-icon")
          v-img(
            :src="require('~/assets/images/person.png')"
            max-width="16"
          )
        div
          div(class="text-14px dark") {{ $t('You') }}
          div(class="text-12px light") {{ $User.email }}
      div(
        v-for="participant in participants"
        :key="participant.id"
        class="form-document-signatures__item"
      )
        div(class="form-document-signatures__item-icon")
          v-img(
            :src="require('~/assets/images/person.png')"
            max-width="16"
          )
        div
          div(class="text-14px dark") {{ _.get(participant, 'user.name') }}
          div(class="text-12px light") {{ _.get(participant, 'user.email') }}
      v-btn(
        class="secondary-button"
        @click="shareDocument(document)"
      ) {{ $t('Share') }}
</template>

<script>
import { mapGetters } from 'vuex'
import dateTime from '~/mixins/datetime/dateTime'
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import documentActions from '~/modules/documents/mixins/documentActions'

export default {
  name: 'FormDocumentSignatures',
  components: {
    EProgressCircular
  },
  mixins: [documentActions, dateTime],
  props: {
    document: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      participantsLoading: false
    }
  },
  computed: {
    ...mapGetters('signatures', {
      signatures: 'items'
    }),
    ...mapGetters('participants', {
      participants: 'items'
    }),
    canSend() {
      return this._.get(this.document, 'canSend', false)
    }
  },
  async created() {
    if (this.$User) {
      await this.getParticipants()
    }
  },
  methods: {
    async getParticipants() {
      try {
        this.participantsLoading = true
        if (!this.participants || !this.participants.length) {
          await this.$store.dispatch('participants/getAllDocumentParticipants', {
            documentId: this.document.id
          })
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.participantsLoading = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-document-signatures {
  &__section {
    border-radius: 12px;
    background: #fff;
    padding: 16px;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
  &__item {
    display: flex;
    align-items: flex-start;
    gap: 16px;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &-icon {
      width: 40px;
      height: 40px;
      border-radius: 12px;

      display: flex;
      align-items: center;
      justify-content: center;

      background: $background-secondary;
    }

    &-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
    }
  }
}
</style>
